import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "cookie-content" };
const _hoisted_2 = { class: "text" };
const _hoisted_3 = ["href"];
import Dialog from "primevue/dialog";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CookieBanner',
    setup(__props) {
        const visible = ref(false);
        const store = useStore();
        const user = computed(() => store.getters["profile/profile"]);
        onMounted(() => {
            if (!localStorage.getItem("cookieAccepted")) {
                visible.value = true;
            }
        });
        async function accept() {
            localStorage.setItem("cookieAccepted", "true");
            if (user?.value?.id) {
                await store.dispatch("writeAuditLog", "acceptCoockie");
            }
            else {
                document.cookie = "isCookiePolicyAccepted=true; path=/";
            }
            visible.value = false;
        }
        const policy = process.env.VUE_APP_POLICY;
        return (_ctx, _cache) => {
            const _component_UButton = _resolveComponent("UButton");
            return (_openBlock(), _createBlock(_unref(Dialog), {
                visible: visible.value,
                "onUpdate:visible": _cache[0] || (_cache[0] = ($event) => ((visible).value = $event)),
                position: "bottom",
                modal: false,
                closable: false,
                draggable: false,
                "dismissable-mask": false,
                class: "cookie-dialog"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("span", _hoisted_2, [
                            _cache[1] || (_cache[1] = _createTextVNode(" We use cookies to offer you a better browsing experience, analyze site traffic and personalize content. By using this site or clicking I agree, you consent to our use of cookies. You can read our policy ", -1)),
                            _createElementVNode("a", {
                                href: _unref(policy),
                                target: "_blank"
                            }, "here", 8, _hoisted_3),
                            _cache[2] || (_cache[2] = _createTextVNode(". ", -1))
                        ]),
                        _createVNode(_component_UButton, { onClick: accept }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                    _createTextVNode(" I agree ", -1)
                                ]))]),
                            _: 1
                        })
                    ])
                ]),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
